import {
  CURRENCY,
  CURRENCY_FAILURE,
  CURRENCY_DETAILS,
  CURRENCY_DETAILS_FAILURE,
  NEWS,
  NEWS_FAILURE,
  COIN_HISTORY,
  COIN_HISTORY_FAILURE,
  CLEAR_STATUS,
  RESET_STATE,
  SET_TAB,
} from "../Actions/Types";

const INIT_STATE = {
  currencyData: [],
  currencyStatus: null,

  newsData: [],
  newsStatus: null,

  coinHistoryData: [],
  coinHistoryStatus: null,

  coinDetailData: [],
  coinDetailStatus: null,

  tab: null,
};

const ReducerTypeOne = (state = INIT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case CURRENCY:
      return {
        ...state,
        currencyData: payload,
        currencyStatus: payload.status,
      };

    case CURRENCY_FAILURE:
      return {
        ...state,
        currencyData: payload,
        currencyStatus: payload.status,
      };

    case NEWS:
      return {
        ...state,
        newsData: payload,
        newsStatus: payload.readLink,
      };

    case NEWS_FAILURE:
      return {
        ...state,
        newsData: payload,
        newsStatus: payload.readLink,
      };

    case COIN_HISTORY:
      return {
        ...state,
        coinHistoryData: payload,
        coinHistoryStatus: payload.status,
      };

    case COIN_HISTORY_FAILURE:
      return {
        ...state,
        coinHistoryData: payload,
        coinHistoryStatus: payload.status,
      };

    case CURRENCY_DETAILS:
      return {
        ...state,
        coinDetailData: payload,
        coinDetailStatus: payload.status,
      };

    case CURRENCY_DETAILS_FAILURE:
      return {
        ...state,
        coinDetailData: payload,
        coinDetailStatus: payload.status,
      };

    case SET_TAB:
      return {
        ...state,
        tab: payload,
      };

    case CLEAR_STATUS:
      return {
        ...state,
        currencyStatus: null,
        newsStatus: null,
        coinHistoryStatus: null,
        coinDetailStatus: null,
      };

    case RESET_STATE:
      return { ...INIT_STATE };

    default:
      return state;
  }
};
export default ReducerTypeOne;
